import { render, staticRenderFns } from "./PiePassageAuthor.vue?vue&type=template&id=8ccac046"
import script from "./PiePassageAuthor.vue?vue&type=script&lang=ts"
export * from "./PiePassageAuthor.vue?vue&type=script&lang=ts"
import style0 from "./PiePassageAuthor.vue?vue&type=style&index=0&id=8ccac046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports